import { callApi } from '../../api/helpers';
import { assessmentApi } from '../../api/openapi-axios-client';

export async function trackBehaviorEvent(
    eventType: string,
    eventData: Record<string, any> = {}
): Promise<void> {
    try {
        await callApi(() => assessmentApi.analytics.trackBehaviorEvent({
            eventType,
            eventData,
        }));
    } catch (error) {
        console.error(`Failed to track behavior event: ${eventType}`, error);
    }
}
